module.exports = __webpack_public_path__ + "img/gc3.ce92c09e.png";